import { BASE_API } from "../../configs/ConfigsConstants";

export async function getRolesApi() {
    try {
        const url = `${BASE_API}/hrm/api/roles/`;
        const params = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
export async function addRoleApi(data) {
    try {
        const url = `${BASE_API}/hrm/api/save_role/`;

        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
export async function updateRoleApi(data, token) {
    try {
        const url = `${BASE_API}/hrm/api/update_role/`;
        const params = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
export async function deleteRoleApi(id) {
    try {
        const url = `${BASE_API}/hrm/api/delete_role/${id}/`;
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}

export async function getRoleBrandsApi(roleId) {
    try {
        const url = `${BASE_API}/hrm/api/role_brands/${roleId}/`;
        const params = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}

export async function addRoleBrandApi(data) {
    try {
        const url = `${BASE_API}/hrm/api/save_role_brand/`;
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return { ...result, status: result.status ?? response.status };
    } catch (error) {
        throw error;
    }
}

export async function deleteRoleBrandApi(id) {
    try {
        const url = `${BASE_API}/hrm/api/delete_role_brand/${id}/`;
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
